<template>
  <div>
    <div class="menu-banner-wrapper">
      <div class="menu-banner-icon">
        <div class="menu-banner-icon-logo" v-html="image"></div>
      </div>
      <div class="menu-banner-contents">
        <h1 class="menu-banner-contents-title">{{ title }}</h1>
        <p class="menu-banner-contents-description" v-html="contents" />
      </div>
      <div class="menu-banner-button-wrapper">
        <a class="menu-banner-button" :href="link" target="_blank">
          <span>
            둘러보기
          </span>
          <i class="fal fa-angle-right fa-lg"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'MenuBanner',
  props: {},
  computed: {
    ...mapState({
      title: (state) => state.banner.menuBanner.title,
      link: (state) => state.banner.menuBanner.link,
      contents: (state) => state.banner.menuBanner.content,
      image: (state) => state.banner.menuBanner.icon,
    }),
  },
});
</script>

<style lang="scss" scoped>
.menu-banner-wrapper {
  display: flex;
  background: #f7f7f7;
  margin-top: auto;
  padding: 20px 12px 16px 20px;
  width: 100%;
  row-gap: 4px;
  column-gap: 12px;
  color: #333;
  flex-wrap: wrap;

  .menu-banner-icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    flex-basis: 20px;

    .menu-banner-icon-logo {
      width: 20px;
      height: 20px;
    }
  }

  .menu-banner-contents {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 4px;

    .menu-banner-contents-title {
      flex-shrink: 0;
      font-weight: 700;
      font-size: 13px;
      line-height: 20px;
    }

    .menu-banner-contents-description {
      flex: 1;
      font-size: 13px !important;
      line-height: 20px;

      word-break: keep-all;
      word-wrap: break-word;
    }
  }

  .menu-banner-button-wrapper {
    flex-basis: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .menu-banner-button {
    height: 26px;
    display: flex;
    justify-content: center;
    gap: 2px;
    padding: 4px;
    align-items: center;

    border-radius: 4px;
    cursor: pointer;
    color: #676767;

    &:hover {
      background-color: #9fa6ad33;
    }

    span {
      height: 21px;
      font-size: 13px;
    }
  }

  @media (min-width: 900px) {
    width: 100%;
    padding: 18px 12px 18px 28px;
    align-items: center;
    gap: 8px;

    .menu-banner-icon {
      flex-basis: 20px;
    }

    .menu-banner-icon-logo {
      width: 20px;
      height: 20px;
    }

    .menu-banner-contents {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;

      .menu-banner-contents-title {
        flex-shrink: 0;
        font-weight: 700;
        font-size: 13px;
        line-height: 20px;
      }

      .menu-banner-contents-description {
        flex: 1;
        font-size: 13px !important;
        line-height: 20px;
        overflow-wrap: break-word; /* 단어 단위로 줄바꿈 */
        word-break: keep-all;
        word-wrap: break-word;
      }
    }

    .menu-banner-button-wrapper {
      flex-basis: 70px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
